import InvoiceManagementGateway from "./invoice-management-gateway";
import InvoiceManagemnt from "./invoice-management";
import formatDate from "@/helpers/formatDate";
import BillingRuleApi from "@/accounting/api/billing-rule-api";
import parseDate from "@/helpers/parseDate";

export default class InvoiceManagementService {
  public constructor(
    private invoices: InvoiceManagementGateway,
    private billingRuleRepository: BillingRuleApi
  ) {}

  public async find(id: number): Promise<InvoiceManagemnt> {
    const invoice = await this.invoices.find(id);
    if (!invoice) {
      throw new Error("invoice is not found.");
    }
    return invoice;
  }

  public async save(invoice: InvoiceManagemnt): Promise<void> {
    await this.invoices.save(invoice);
  }

  /**
   * ステータスを変更する
   */
  public async changeStatus(id: string, status: string): Promise<void> {
    const invoice = await this.find(Number(id));
    invoice.status = status;
    await this.save(invoice);
  }

  // public async invoice(estimate: Estimate): Promise<number> {
  //   const rule = await this.billingRuleRepository.findByProject(
  //     String(estimate.projectId)
  //   );
  //   const billingDate = new Date();
  //   const invoice = {
  //     estimateId: estimate.id,
  //     projectId: estimate.projectId,
  //     projectName: estimate.projectName,
  //     title: estimate.title,
  //     status: "created",
  //     total: estimate.total,
  //     subtotal: estimate.subtotal,
  //     tax: estimate.tax,
  //     taxRate: estimate.taxRate,
  //     billingDate: formatDate(billingDate),
  //     dueDate: formatDate(rule.getDueDate(billingDate)),
  //     bankAccount1: "",
  //     bankAccount2: "",
  //     bankAccount3: "",
  //     deposit: 0,
  //     depositRequestedAt: "",
  //     totalWithDeposit: estimate.total,
  //     items: estimate.items.map(i => ({
  //       id: uuid(),
  //       unitName: i.unitName,
  //       unitType: i.unitType,
  //       unitPrice: i.unitPrice,
  //       amount: i.amount,
  //       totalPrice: i.totalPrice,
  //       memo: i.memo,
  //       items: i.items.map(j => ({
  //         id: uuid(),
  //         unitName: j.unitName,
  //         unitType: j.unitType,
  //         unitPrice: j.unitPrice,
  //         amount: j.amount,
  //         totalPrice: j.totalPrice,
  //         memo: j.memo,
  //         items: []
  //       }))
  //     }))
  //   };
  //   return await this.invoices.save(invoice);
  // }

  public async destroy(id: number): Promise<void> {
    await this.invoices.destroy(id);
  }

  /**
   * 入金予定日を得る
   */
  public async getDueDate(
    billingDate: string,
    projectId: string
  ): Promise<string> {
    const date = parseDate(billingDate);
    const rule = await this.billingRuleRepository.findByProject(projectId);
    return formatDate(rule.getDueDate(date));
  }
}
